import { render, staticRenderFns } from "./RequiredDisclosures.vue?vue&type=template&id=042a124c"
import script from "./RequiredDisclosures.vue?vue&type=script&lang=ts"
export * from "./RequiredDisclosures.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports